import React from 'react'
import { makeStyles } from '@material-ui/core'
import ErrorBoundary from '../../errorBoundaryComponent/ErrorBoundaryComponent'

const useStyles = makeStyles(() => ({
  content: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
}))

const ComponentWrapperComponent = ({ component }) => {
  const classes = useStyles()
  return (
    <ErrorBoundary>
      <div className={classes.content}>{component}</div>
    </ErrorBoundary>
  )
}

export default ComponentWrapperComponent
